import React, { useState } from "react";
import { LegislationRef } from "../../../models/legislations";
import { LegislationEmployeeCostSectionRef } from "../../../models/legislation-employee-cost-section/legislation-employee-cost-section-ref";
import { LegislationSocialSecurityCostDTO } from "../../../models/legislation-social-security-cost/legislation-social-security-cost-dto";
import { Button, Dialog, DialogContent, Grid, IconButton } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGear } from "@fortawesome/free-solid-svg-icons";
import DialogTitle from "../../DialogTitle/DialogTitle";
import SocialSecurityCostConfiguration from "./SocialSecurityCostConfiguration/SocialSecurityCostconfiguration";
import EmployeeCostSectionConfiguration from "./EmployeeCostSectionConfiguration/EmployeeCostSectionConfiguration";
import { useTranslation } from "react-i18next";

interface Props {
  legislation: LegislationRef;
  sections: LegislationEmployeeCostSectionRef[];
  socialSecurityConfig: LegislationSocialSecurityCostDTO | null;
  configurationTypeName?: string;
}

interface State {
  open: boolean;
  displaySocialSecurity: boolean;
}

const LegislationSectionConfiguration = ({
  sections,
  legislation,
  socialSecurityConfig,
  configurationTypeName,
}: Props) => {
  const { t } = useTranslation();
  const tRP = "components.add_edit_proforma_employee_cost_report.legislation_configuration";
  const theme = useTheme();

  const [state, setState] = useState<State>({
    open: false,
    displaySocialSecurity: false,
  });

  return (
    <>
      <IconButton onClick={() => setState((state) => ({ ...state, open: true }))}>
        <FontAwesomeIcon icon={faGear} />
      </IconButton>

      <Dialog
        open={state.open}
        maxWidth="lg"
        fullWidth
      >
        <DialogTitle
          title={`${t(`${tRP}.dialog_title`, { legislationName: legislation.name })}`}
          handleClose={() => setState((state) => ({ ...state, open: false }))}
          subtitle={configurationTypeName ?? ""}
        />
        <DialogContent>
          <Grid>
            <Button
              onClick={() => setState((state) => ({ ...state, displaySocialSecurity: false }))}
              style={{
                textTransform: "none",
                color: state.displaySocialSecurity ? theme.palette.primary.main : theme.palette.secondary.light,
              }}
            >
              {`${t(`${tRP}.employee_cost_sections`)}`}
            </Button>
            <Button
              onClick={() => setState((state) => ({ ...state, displaySocialSecurity: true }))}
              style={{
                textTransform: "none",
                color: state.displaySocialSecurity ? theme.palette.secondary.light : theme.palette.primary.main,
              }}
            >
              {`${t(`${tRP}.social_security_sections`)}`}
            </Button>
          </Grid>
          {state.displaySocialSecurity ? (
            <SocialSecurityCostConfiguration socialSecurityConfig={socialSecurityConfig} />
          ) : (
            <EmployeeCostSectionConfiguration
              legislation={legislation}
              sections={sections}
              socialSecurityConfig={socialSecurityConfig}
            />
          )}
        </DialogContent>
      </Dialog>
    </>
  );
};
export default LegislationSectionConfiguration;
